import React, { ReactElement } from 'react';
import InnerBlock from '../../../../shared/web/layout/InnerBlock';
import { ClickableBlock, useProjectTypeHelper } from 'features/tasks-forms';
import { useSetupAreaVersionContextRequired } from '../SetupAreaVersionContext';
import { Text, usePopupManager } from 'ui-builder';
import { ProjectType, useContractTemplateAdminService } from 'nekst-api';
import {
  IconDeleteButton,
  Popup,
  PreviewFileWidget,
  usePopupFormManager
} from 'features/nekst-widgets';
import { CreateContractTemplateForm } from './CreateContractTemplateForm';
import ManageAiTrainingDataWidget from '../../../projectdetails/aitraining/ManageAiTrainingDataWidget';
import MarketsBreadcrumbs from '../MarketsBreadcrumbs';

function DeleteContractTemplateButton(props: {
  contractTemplateId: number;
}) {
  const contractTemplateService = useContractTemplateAdminService();

  return (
    <IconDeleteButton
      deleteFunc={async () => {
        await contractTemplateService.deleteContractTemplate(
          props.contractTemplateId
        );
      }}
      message="Are you sure you want to delete this contract template? This action cannot be undone."
    />
  );
}

export function AiTrainingPage() {

  const projectTypesHelper = useProjectTypeHelper();

  const { setupArea, setupAreaVersion } = useSetupAreaVersionContextRequired();


  const getContractTemplate = (projectType: ProjectType) => {
    return setupAreaVersion.contractTemplates.find(
      (template) => template.projectType === projectType
    );
  };

  const popupFormManager = usePopupFormManager();

  const popupManager = usePopupManager();

  return (
    <InnerBlock title={`${setupArea.name}: AI Training`}>
      <MarketsBreadcrumbs text="AI Training" />
      {projectTypesHelper.getTypes()
        .map((type) => {
          const contractTemplate = getContractTemplate(type);

          let content: ReactElement;

          if (contractTemplate) {
            content = (
              <PreviewFileWidget file={contractTemplate.exampleFile} />
            );
          } else {
            content = (
              <Text>Click to download a contract template</Text>
            );
          }

          return (
            <ClickableBlock
              title={`${projectTypesHelper.getLabel(type)}`}
              content={content}
              buttons={contractTemplate ? <DeleteContractTemplateButton
                contractTemplateId={contractTemplate.id} /> : undefined}
              onClick={() => {
                if (!contractTemplate) {
                  popupFormManager.openForm(
                    <CreateContractTemplateForm
                      setupAreaId={setupArea.id}
                      setupAreaVersion={setupAreaVersion.version}
                      projectType={type}
                    />
                  );
                } else {
                  popupManager.openPopup(
                    <Popup
                      isBig
                      title="AI Training"
                      content={(<ManageAiTrainingDataWidget
                        contractTemplateId={contractTemplate.id}
                      />)}
                    />
                  );
                }
              }}
            />
          );
        })}
    </InnerBlock>
  );
}
